const EventBus = new Vue()
// LOG HERE ALL EVENTS
// 
// 'unselect-all-products' () --> <emit> store.shop </emit>  <on> components.shop-product </on>
// 'select-all-products' () --> <emit> views.shop </emit>  <on> components.shop-product </on>

// 'show-country-selector-modal' () --> <emit> components.navbar </emit>  <on> components.country-selector-modal </on>
// 'hide-country-selector-modal' () --> <emit> components.navbar </emit>  <on> components.country-selector-modal </on>

// 'show-country-selector-confirm-modal' () --> <emit> components.country-selector-modal </emit>  <on> components.country-selector-confirm-modal </on>
// 'hide-country-selector-confirm-modal' () --> <emit> components.country-selector-modal </emit>  <on> components.country-selector-confirm-modal </on>

// 'shop-select-all-filters' () --> <emit> views.shop </emit>  <on>  components.shop-filters-product</on>
// 'shop-unselect-all-filters' () --> <emit> views.shop | store.shop.getProducts() </emit>  <on> components.shop-filters-product </on>

// 'shop-cart-items-change' () --> <emit> store.shop </emit>  <on>  components.cart-icon</on>


// 'show-cart' () --> <emit> components.cart-icon </emit>  <on> components.cart-drawer </on>
// 'hide-cart' () --> <emit> components.cart-icon </emit>  <on> components.cart-drawer </on>




//components.shop-filters-product-checkbox